import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-envelope',
  templateUrl: './icon-envelope.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconEnvelopeComponent {}
